<template>
  <div>
    <div class="columns is-vcentered">
      <div class="column is-narrow">
        <button
          class="button"
          @click="$emit('decrement-item-quantity', product.barcode)"
        >
          <b-icon icon="minus-circle" type="is-deep-purple"></b-icon>
        </button>
      </div>

      <div class="column is-narrow">
        <button
          class="button"
          @click="$emit('increment-item-quantity', product.barcode)"
        >
          <b-icon icon="plus-circle" type="is-primary"></b-icon>
        </button>
      </div>

      <div class="column is-narrow quantity-column">
        {{ product.quantity }} x
      </div>

      <div class="column product-name">
        {{ product.name }}
      </div>

      <div class="column is-narrow has-text-right">
        <money
          v-model="product.price"
          v-bind="money"
          readonly
          class="input-price"
        ></money>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mask } from "../../mixins/mask";
import { Money } from "v-money";

export default {
  props: ["product"],

  mixins: [mask],

  components: {
    Money
  },

  data() {
    return {
      NODE_ENV: process.env.NODE_ENV
    };
  },

  computed: {
    ...mapGetters(["payments"]),

    money() {
      return {
        decimal: ",",
        thousands: ".",
        prefix: `${this.payments.currencySymbol} `,
        precision: 2
      };
    }
  }
};
</script>

<style scoped>
.quantity-column {
  padding-left: 1rem;
  padding-right: 1rem;
}

.product-name {
  font-weight: 600;
  text-align: left;
}

.input-price {
  all: unset;
}
</style>
